import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, type Link } from '@mui/material';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';
import { pxToRem } from '@/utils/pxToRem';
import type { EntityLinkData } from '../hooks/useAssetLinks';

const entityLinkStyles = {
  text: {
    position: 'relative',
    fontSize: pxToRem(12),
    letterSpacing: pxToRem(1),
    textDecoration: 'none',
    display: 'inline-flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
    gap: '0.125rem',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  icon: {
    fontSize: '0.75rem',
  },
};

type EntityLinkProps = {
  link: EntityLinkData | null;
} & ComponentProps<typeof Link>;

const EntityLink = ({ link, sx, children }: EntityLinkProps) => {
  if (!link?.url) {
    return null;
  }

  const displayText = children ?? `${link.name}`;

  return (
    <Box
      href={link.url}
      target='_blank'
      rel='noopener noreferrer'
      color='text.secondary'
      sx={combineSx(entityLinkStyles.text, sx)}
      data-id='entity-link'
      component='a'
    >
      {displayText}
      <OpenInNewIcon sx={entityLinkStyles.icon} />
    </Box>
  );
};

export { EntityLink };
export type { EntityLinkProps };
